module.exports = __webpack_public_path__ + "img/FAAS_Strategic_Initiative_PR_4.22.24_bahasaRevFN_-_revLgl.7d07a42c.png";